import { useLocation } from "react-router-dom";
import { ReportLoadingProvider } from "../../../../contexts/ReportLoadingContext";
import { ReportRoute } from "../../../../components/Dashboard/ReportLayout/ReportRoute";
import { InfoCattleMap } from "../../../../components/Dashboard/ViewDatas/InfoCattleMap";
import { LeafletMap } from "../../../../components/Leaflet/LeafletMap/Index";
import { getCenterCoords } from "../../../../utils/leaflet/getCenterCoords";
import { IOptionProps } from "../../../../@types/reactSelect/IOption";
import { IMicroAreas } from "../../../../@types/API/IMicroArea";
import { ICoords } from "../../../../@types/GoogleMaps/ICoord";
import { IBatches } from "../../../../@types/API/IBatches";
import { useFilter } from "../../../../hooks/useFilter";
import { ReactNode, useCallback, useEffect, useState } from "react";
import { IAreas } from "../../../../@types/API/IArea";
import { IFarms } from "../../../../@types/API/IFarm";
import "../styles.css"
import { InfoManagements } from "../../../../components/Dashboard/ViewDatas/InfoManagements";
import { InfoBatches } from "../../../../components/Dashboard/ViewDatas/InfoBatches";
import { InfoCarbon } from "../../../../components/Dashboard/ViewDatas/InfoCarbon";
import { FilterDataPolygonsV2 } from "../../../../components/PaddocksMap/FilterDataPolygons/FilterDataPolygonsV2";
import { useTranslation } from "react-i18next";

type MapsIndexProps = {
  children: ReactNode;
};

type ICustomFarm = {
  id: string;
  initials: string;
  coords: ICoords;
  name: string;
  bgColor: string;
};

type ICustomArea = {
  id: string;
  initials: string;
  coords: ICoords;
  name: string;
  bgColor: string;
  farmId: string;
};

export function Index({ children }: MapsIndexProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const {
    farmFilter,
    setFarmFilter,
    areaFilter,
    setAreaFilter,
    setMicroArea,
    hideMicroAreaFilter,
    setMicroAreaDefaultOption,
    microAreaDefaultOption,
    setBatchFilter,
    setBatchDefaultOption,
    batchDefaultOption,
    hideBatchFilter,
    sideBarOptionSelected,
    dashboard
  } = useFilter();

  const [farmsData, setFarms] = useState<IFarms>([]);
  function getFarmsFiltereds(farms: IFarms) {
    const [currentFiltered] = farms;
    const current = farmsData.find((f) => f.id === currentFiltered.id);
    if (current) {
      const { id, initials, name, map_coords: coords } = current;
      const customFarm = { id, initials, name, coords } as ICustomFarm;
      // setFarmFilter(customFarm);
    }
    setAreaFilter(undefined);
    setMicroArea(undefined);
    setMicroAreaDefaultOption(undefined);
    setBatchDefaultOption(undefined);
    setBatchFilter(undefined);
  }

  function defaultValueFarm() {
    if (!farmFilter) return undefined;
    return {
      label: `${farmFilter.name}`,
      value: farmFilter?.id,
    } as IOptionProps
  }

  const [areasData, setAreasData] = useState<IAreas>([]);
  function getAreasFiltereds(areas: IAreas) {
    const [currentFiltered] = areas;
    if (currentFiltered) {
      const current = areasData.find((f) => f.id === currentFiltered.id);
      if (current && farmFilter) {
        const { id, initials, name, map_coords: coords } = current;
        const customArea = { id, initials, name, coords, farmId: farmFilter.id as string } as ICustomArea;
        setAreaFilter({ ...customArea, bgColor: "" });
      }
    } else setAreaFilter(currentFiltered);
    setMicroArea(undefined);
    setBatchFilter(undefined);
    setMicroAreaDefaultOption(undefined);
    setBatchDefaultOption(undefined);
  }

  function defaultValueArea() {
    if (!areaFilter) return undefined;
    return {
      label: `${areaFilter.name}`,
      value: areaFilter?.id,
    } as IOptionProps;
  }

  function getMicroAreasFiltereds(microAreas: IMicroAreas) {
    const [microArea] = microAreas;
    if (microArea) {
      const { area_id, id, initials, map_coords, micro_area_route } = microArea as any;
      setMicroArea({
        areaId: area_id,
        id,
        coords: map_coords,
        initials,
        microAreaRoute: {
          batch: micro_area_route ? micro_area_route.batch : null,
          current: micro_area_route ? micro_area_route.micro_area_route : false,
        },
      });
    } else setMicroArea(undefined);
  }

  function getBatchesFiltereds(batches: IBatches) {
    const [batch] = batches;
    if (batch) {
      setBatchFilter({
        areaId: batch.area.id,
        capacityRate: batch.batch_capacity_rate,
        coords: getCenterCoords(batch.current_micro_area.map_coords),
        farmId: farmFilter.id,
        id: batch.id,
        initials: batch.initials,
        microAreaId: batch.current_micro_area.id,
      });
    } else setBatchFilter(undefined);
  }

  useEffect(() => {
    if (!farmFilter && farmsData.length > 0) {
      const [farm] = farmsData;
      const { id, initials, map_coords: coords, name } = farm;
      // setFarmFilter({
      //   id,
      //   initials,
      //   coords,
      //   name,
      // } as ICustomFarm);
      setAreaFilter(undefined);
    }
  }, [farmFilter, farmsData]);

  // Estados para controle mobile
  const [isMobile, setIsMobile] = useState(false);
  const [isContainerVisible, setIsContainerVisible] = useState(true);
  const [isFilterIconVisible, setIsFilterIconVisible] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const shouldHideFilterControls = isMobile && isSidebarExpanded;

  const collapseContainer = useCallback(() => {
    if (!isMobile || shouldHideFilterControls) return;

    setIsFilterIconVisible(true);
    setIsContainerVisible(false);
  }, [isMobile, shouldHideFilterControls]);

  // Detectar se é mobile
  useEffect(() => {
    const checkMobile = () => {
      const nextIsMobile = window.innerWidth <= 768;
      setIsMobile(nextIsMobile);

      if (!nextIsMobile) {
        setIsContainerVisible(true);
        setIsFilterIconVisible(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Escutar interações com o Leaflet
  useEffect(() => {
    const handleLeafletInteraction = () => {
      collapseContainer();
    };

    window.addEventListener('leafletInteraction', handleLeafletInteraction);

    return () => {
      window.removeEventListener('leafletInteraction', handleLeafletInteraction);
    };
  }, [collapseContainer]);

  // Escutar cliques/interações no background dos dashboards
  useEffect(() => {
    const handleCattleMapBackgroundInteraction = (event: MouseEvent | TouchEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.cattleMap_background')) return;

      collapseContainer();
    };

    document.addEventListener('click', handleCattleMapBackgroundInteraction);
    document.addEventListener('touchstart', handleCattleMapBackgroundInteraction);

    return () => {
      document.removeEventListener('click', handleCattleMapBackgroundInteraction);
      document.removeEventListener('touchstart', handleCattleMapBackgroundInteraction);
    };
  }, [collapseContainer]);

  // Escutar toggle da sidebar para esconder/mostrar botão em mobile
  useEffect(() => {
    const handleSidebarToggle = (event: CustomEvent) => {
      setIsSidebarExpanded(event.detail.isOpen);
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle as EventListener);

    return () => {
      window.removeEventListener('sidebarToggle', handleSidebarToggle as EventListener);
    };
  }, []);

  const toggleContainer = () => {
    setIsContainerVisible((isVisible) => !isVisible);
    setIsFilterIconVisible(false);
  };

  if (pathname.includes("/dashboard/")) {
    return <ReportLoadingProvider key={pathname}><ReportRoute>{children}</ReportRoute></ReportLoadingProvider>;
  }

  return (
    <>
      {/* Botão de filtro - aparece quando o container está escondido */}
      {isMobile && isFilterIconVisible && !isContainerVisible && !shouldHideFilterControls && (
        <button
          className="paddocktime__filter-button"
          onClick={toggleContainer}
          aria-label={t("mapTools.toggleFilter")}
        >
          <span className="material-symbols-outlined">filter_list</span>
        </button>
      )}

      {/* Container - aparece quando não é mobile OU quando é mobile, container está visível e sidebar está contraída */}
      <section
        className={`paddocktime__container ${!isContainerVisible || (isMobile && isSidebarExpanded) ? 'paddocktime__container--hidden' : ''}`}
      >
        {(sideBarOptionSelected != "DASHBOARD" || (sideBarOptionSelected == "DASHBOARD" && dashboard != "EXPORT")) ?
          <FilterDataPolygonsV2 />
          : null
        }

        {sideBarOptionSelected == "DASHBOARD" && dashboard == "CARBON" && <InfoCarbon />}
        {sideBarOptionSelected == "DASHBOARD" && dashboard == "CATTLE_MAP" && <InfoCattleMap />}
        {sideBarOptionSelected == "DASHBOARD" && dashboard == "BATCHES" && <InfoBatches />}
        {sideBarOptionSelected == "DASHBOARD" && dashboard == "MANAGEMENT_PASTURE" && <InfoManagements />}
      </section>

      {sideBarOptionSelected != "DASHBOARD" ? <LeafletMap>{children}</LeafletMap> : children}
    </>
  );
}
